import cx from 'classnames'
import React from 'react'

import styles from './form-label.module.scss'

export type TProps = {
  children: React.ReactNode
  htmlFor?: string
  className?: string
}

export default function FormLabel(props: TProps) {
  const { children, htmlFor, className } = props

  return (
    <label htmlFor={htmlFor} className={cx(styles.root, className)}>
      {children}
    </label>
  )
}
